import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const EditShiftTimeModal = ({ show, onClose, shifttimeId, onUpdated }) => {
    const [shifttimeName, setShifttimeName] = useState('');
    const [description, setDescription] = useState('');
    const [serviceStartTime, setServiceStartTime] = useState(null);
    const [serviceEndTime, setServiceEndTime] = useState(null);
    const [errors, setErrors] = useState({});
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // Helper to convert "HH:mm:ss" to DateObject
    const parseTimeString = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(':');
        return new DateObject({
            hour: parseInt(hours),
            minute: parseInt(minutes),
        });
    };

    useEffect(() => {
        if (shifttimeId && show) {
            axios.get(`${baseURL}/shifttime/${shifttimeId}`)
                .then(response => {
                    const { data } = response.data;

                    setShifttimeName(data.shifttime_name);
                    setDescription(data.description);
                    setServiceStartTime(parseTimeString(data.shift_start_time));
                    setServiceEndTime(parseTimeString(data.shift_end_time));
                })
                .catch(error => {
                    console.error("Error fetching shift time:", error);
                });
        }
    }, [shifttimeId, show]);

    const handleSubmit = () => {
        setErrors({});

        if (!shifttimeName || !serviceStartTime || !serviceEndTime) {
            setErrors({
                shifttime_name: !shifttimeName ? 'This Field is Required' : '',
                shift_times: (!serviceStartTime || !serviceEndTime) ? 'Start and End times are required' : ''
            });
            return;
        }

        const payload = {
            shifttime_name: shifttimeName,
            description,
            shift_start_time: serviceStartTime.format("HH:mm:ss"),
            shift_end_time: serviceEndTime.format("HH:mm:ss")
        };

        axios.put(`${baseURL}/shifttime/${shifttimeId}`, payload)
            .then(() => {
                
                onClose();
                if (onUpdated) onUpdated();
                toast.success("Shift Time Updated successfully!"); 
            })
            .catch(error => {
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    console.error("Update failed:", error);
                }
            });
    };

    return (
        <Modal show={show} onHide={onClose} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Edit Shift Time</h3>
                    <Button variant="link" className="close" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label>Shift Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                value={shifttimeName}
                                onChange={(e) => setShifttimeName(e.target.value)}
                                placeholder="Enter Shift Name"
                            />
                            {errors.shifttime_name && <div className="text-danger">{errors.shifttime_name}</div>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label>Start Time <span className="text-danger">*</span></label>
                            <div className="datepicker-wrapper d-flex">
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className="fa-solid fa-clock fs-4"></i>
                                </div>
                                <DatePicker
                                    disableDayPicker
                                    value={serviceStartTime}
                                    onChange={setServiceStartTime}
                                    format="hh : mm A"
                                    plugins={[<TimePicker />]}
                                    placeholder="Select Start Time"
                                />
                            </div>
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label>End Time <span className="text-danger">*</span></label>
                            <div className="datepicker-wrapper d-flex">
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className="fa-solid fa-clock fs-4"></i>
                                </div>
                                <DatePicker
                                    disableDayPicker
                                    value={serviceEndTime}
                                    onChange={setServiceEndTime}
                                    format="hh : mm A"
                                    plugins={[<TimePicker />]}
                                    placeholder="Select End Time"
                                />
                            </div>
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label>Description</label>
                            <textarea
                                className="form-control"
                                rows={4}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Description"
                            />
                        </div>
                    </div>

                    {/* <div className="d-flex justify-content-end gap-3 mt-3">
                        <Link className="btn btn-secondary btn-sm" onClick={onClose}>Cancel</Link>
                        <Link className="btn btn-primary btn-sm" onClick={handleSubmit}>Update</Link>
                    </div> */}

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Shift Time
                        <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditShiftTimeModal;
